
export default [
  /** 储值缴费 */
  {
    path: '/storedValuePay',
    name: 'StoredValuePay',
    component: () => import('@/view/pay/stored/Index')
  },
  {
    path: '/storedValuePay/chargeOrderConfirm/:id',  // 确认订单
    name: 'StoredConfirmOrder',
    component: () => import('@/view/pay/stored/ChargeOrderConfirm')
  },
  {    path: '/storedValuePay/selectPark',  // 选择停车场
    name: 'StoredSelectPark',
    component: () => import('@/components/common/SelectPark.vue'),
    props: { payType: 'stored' }
  },

  /** 临停缴费 */
  {
    path: '/temporary/prepay',
    name: 'TemporaryFee',
    component: () => import('@/view/pay/temp/Prepay')
  },
  {
    path: '/temporary/fee',
    name: 'TemporaryFee',
    component: () => import('@/view/pay/temp/Fee')
  },
  {
    path: '/temporary/order',
    name: 'TemporaryOrder',
    component: () => import('@/view/pay/temp/Order')
  },
  {
    path: '/temporary/chargeOrderConfirm/:id',  // 确认订单
    name: 'TempChargeOrderConfirm',
    component: () => import('@/view/pay/temp/ChargeOrderConfirm')
  },

  /** 月租缴费 */
  {
    path: '/monthRentPay',
    name: 'MonthRentPay',
    component: () => import('@/view/pay/month/Index')
  },
  {
    path: '/monthRentPay/chargeOrderConfirm/:id',  // 确认订单
    name: 'MonComfirmOrder',
    component: () => import('@/view/pay/month/ChargeOrderConfirm')
  },
  {    path: '/monthRentPay/selectPark',  // 选择停车场
    name: 'SelectPark',
    component: () => import('@/components/common/SelectPark.vue'),
    props: { payType: 'month' }
  },
  {
    path: '/monthRentPay/addCar',
    name: 'SelectPark',
    component: () => import('@/view/pay/month/addCar')
  },
  {
    path: '/monthRentPay/cars',
    name: 'SelectPark',
    component: () => import('@/view/pay/month/Cars')
  },
  { // 支付结果页面
    path: '/payResult',
    name: 'PayResult',
    component: () => import('@/view/PayResult')
  },
  { // 支付结果页面
    path: '/newPayResult',
    name: 'NewPayResult',
    component: () => import('@/view/NewPayResult')
  },
]



// WEBPACK FOOTER //
// ./src/router/pay.js